import { render, staticRenderFns } from "./AdditionalMessageActions.vue?vue&type=template&id=7e739f60&scoped=true&"
import script from "./AdditionalMessageActions.vue?vue&type=script&lang=ts&"
export * from "./AdditionalMessageActions.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalMessageActions.vue?vue&type=style&index=0&id=7e739f60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e739f60",
  null
  
)

export default component.exports